<template>
  <div class="header__UfFXk">
    <div class="headerContentContainer__2zSyJ">
      <h1>{{ $t('title') }}</h1>
      <p>{{ $t('subtitle') }}</p>
      <div class="headerContentImage__3j_8L"></div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<i18n>
{
  "en": {
    "title": "How Dexmo Force Feedback Gloves Are Made",
    "subtitle": "Hi. This is Aler Gu (Xiaochi Gu), the CEO of Dexta Robotics. We have been exploring with different means of human-machine-interactions for VR/MR since 2014, searching for the most intuitive solution for everyone. To be more specific: we have long been trying to make force feedback gloves a reality."
  },
  "zh": {
    "title": "Dexmo力反馈手套的创造史",
    "subtitle": "Hi，我是Dexta Robotics的CEO，Aler Gu（谷逍驰）。自2014年以来，我们一直在探索VR/MR中的人机交互方式，致力于寻找适用于所有人的最自然直觉的解决方案。我们一直在努力让力反馈手套成为现实。"
  }
}
</i18n>

<style></style>
